
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiAlertGrid extends Serenity.EntityGrid<UtentiProdottiAlertRow, any> {
        protected getColumnsKey() { return UtentiProdottiAlertColumns.columnsKey; }
        protected getDialogType() { return UtentiProdottiAlertDialog; }
        protected getIdProperty() { return UtentiProdottiAlertRow.idProperty; }
        protected getInsertPermission() { return UtentiProdottiAlertRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiProdottiAlertRow.localTextPrefix; }
        protected getService() { return UtentiProdottiAlertService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: false,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 300
            });

            return this.slickGrid;
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            //opt.rowHeight = 150;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return true;
        }

        protected createQuickSearchInput() { }

        protected getGridCanLoad() {
            return (this.IdUtenteProdotto > 0);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            return buttons;
        }

        // ///////////////////////////////////////////////////////////////
        private _IdUtenteProdotto: number;

        get IdUtenteProdotto() {
            return this._IdUtenteProdotto;
        }

        set IdUtenteProdotto(value: number) {
            if (this._IdUtenteProdotto != value) {
                this._IdUtenteProdotto = value;
                this.setEquality(UtentiProdottiAlertRow.Fields.IdUtenteProdotto, value);
                this.refresh();
            }
        }
    }
}